import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
import { Pill } from './Pill';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-paper-soft py-14 sm:py-20" aria-labelledby="guarantee-heading" data-id="element-98" data-mp="4x345xqdflhz">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-99" data-mp="etfxuvlx1zcq">
        <Medallion icon={ShieldCheckIcon} data-id="element-100" data-mp="ev0qugsl1a8h" />

        <div className="mt-6" data-id="element-101" data-mp="jsshl7hhqqb3">
          <Pill tone="pine" data-id="element-102" data-mp="jrhgxgjcdyo7">Garanzia di 7 giorni</Pill>
        </div>
        <h2 id="guarantee-heading" className="mx-auto mt-5 max-w-xl font-display text-[2.3rem] font-bold uppercase leading-none text-pine sm:text-5xl" data-id="element-103" data-mp="ntvzdzj3mwey">
          100% protetto
        </h2>

        <p className="mx-auto mt-7 max-w-prose font-sans text-base leading-relaxed text-ink-muted" data-id="element-104" data-mp="xjxkqjk2i0q6">
          Accedi al sistema completo e verifica di aver ricevuto i 6 volumi e i
          5 bonus dettagliati in questa pagina.
        </p>
        <p className="mx-auto mt-4 max-w-prose font-sans text-base leading-relaxed text-ink-muted" data-id="element-105" data-mp="17j6cd5rgn39d">
          Se qualche file è incompleto, presenta problemi di accesso o il
          contenuto non corrisponde alla descrizione di questa offerta,
          scrivici entro 7 giorni.
        </p>
        <p className="mx-auto mt-4 max-w-prose font-sans text-base leading-relaxed text-ink-muted" data-id="element-106" data-mp="1vuskyhwbeofj">
          Lo controlleremo e, se non riusciamo a risolvere il problema, ti
          rimborseremo il{' '}
          <span className="font-semibold text-ink" data-id="element-107" data-mp="2ohdenp09jcm9">100% del tuo acquisto</span>.
        </p>
        <p className="mt-7 font-display text-2xl font-bold uppercase tracking-wide text-pine" data-id="element-108" data-mp="2jkd53447frqe">
          Rischio zero per te.
        </p>
      </div>
    </section>;
}